export default __webpack_public_path__ + "static/media/goshen81.bb02b0df.jpg";